<template>
    <div class="mb-4 mb-lg-0">
        <div class="card">
            <div class="card-body">
                <div v-if="$slots.header">
                    <slot name="header"></slot>
                </div>
                <div v-else>
                    <h4 v-if="titleBig" class="mb-4 ui-card-title">{{ title }}</h4>
                    <h6 v-else class="mb-4 ui-card-title">{{ title }}</h6>
                </div>
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        titleBig: {
            type: Boolean,
            default: false
        }
    }
}
</script>